module.exports = __webpack_public_path__ + "b24e1b5786f312693a1d4f2dce93e0d5.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/projekte/festival03.jpg
// module id = 794
// module chunks = 0